module.exports = __webpack_public_path__ + "img/5-fr.7fd54208.jpg";